import { View, Text, StyleSheet } from "@react-pdf/renderer";
import { VotacaoParticipanteItem } from "core/features/assembleia/typings";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { PDFLayout } from "ui/components/PDF";
import colors from "core/resources/theme/colors";

interface PDFListaParticipantesPrintProps {
  votacaoNome: string;
  participantes: VotacaoParticipanteItem[] | undefined;
}

function PDFListaParticipantes({
  votacaoNome,
  participantes,
}: PDFListaParticipantesPrintProps) {
  const { tenant } = useCurrentTenant();

  const ParticipanteItem = ({
    participante,
  }: {
    participante: VotacaoParticipanteItem;
  }) => {
    const unidadesString = participante.unidades
      .map((u) =>
        u.blocoQuadra
          ? `${u.numero} / Bloco ${u.blocoQuadra.nome?.replace(
              /^Bloco/i,
              ""
            )}, peso: ${u.peso ?? 0}${u.inadimplente ? " (inadimplente)" : ""}`
          : `${u.numero}, peso: ${u.peso ?? 0}${
              u.inadimplente ? " (inadimplente)" : ""
            }`
      )
      .join(" | ");

    const isSingleUnidade = participante.unidades.length === 1;

    return (
      <View style={styles.participanteItem}>
        <Text style={styles.nome}>
          {participante.pessoa.nome}
          {participante.dataCheckin ? " (já adicionado)" : ""}
        </Text>
        <Text style={styles.unidades}>
          {isSingleUnidade ? "Unidade: " : "Unidades: "}
          {unidadesString}
        </Text>
      </View>
    );
  };

  return (
    <PDFLayout
      fontSize={10}
      orientation="portrait"
      includeDocument={true}
      headerProps={{
        logo: tenant.imagemUrl,
        tenant: tenant.nome,
        title: "Lista de participantes",
        subTitle: votacaoNome,
        topRightAdmLogo: true,
        fixed: true,
      }}
    >
      <View style={styles.container}>
        {participantes?.map((participante) => (
          <ParticipanteItem key={participante.id} participante={participante} />
        ))}
      </View>
    </PDFLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    width: "100%",
  },
  participanteItem: {
    flexDirection: "column",
    marginBottom: 4,
    paddingBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: colors.lightGray,
  },
  nome: {
    fontSize: 9,
    marginBottom: 2,
  },
  unidades: {
    fontSize: 7.5,
    color: colors.black700,
  },
});

export default PDFListaParticipantes;
